import * as React from "react";
import {useTranslation} from "react-i18next";

interface IShippingPartialProps {
  isAllowed: boolean;
  onPartialDelivery: (partial: boolean) => void;
}

/**
 * single row to set if partial delivery is desired
 * @param props
 * @constructor
 */
const ShippingPartial: React.FC<IShippingPartialProps> = (props: IShippingPartialProps) => {
  const {t} = useTranslation("checkout");
  const {isAllowed, onPartialDelivery} = props;

  return (
    <div className="SimpleRadioList ArrowBorder" style={{float: "left"}}>
      <div className="SimpleRadioList__Row">
        <label htmlFor="AllowPartialDelivery">
          <div className="SimpleRadioList__Row__Radio">
            <input
              type="checkbox"
              name="partial"
              id="AllowPartialDelivery"
              defaultChecked={isAllowed}
              onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                onPartialDelivery(evt.target.checked);
              }}
            />
          </div>
          <div>{t("Ich wünsche Teillieferungen ...")}</div>
        </label>
      </div>
    </div>
  );
};

export default ShippingPartial;
